import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import styles from "./ViewFullDetails.module.scss";

type Props = {
  handleViewFullDetailsPage: () => void;
};

export const ViewFullDetailsUI = ({ handleViewFullDetailsPage }: Props) => {
  return (
    <div data-component="ViewFullDetails">
      <SecondaryButton
        onClick={handleViewFullDetailsPage}
        width="full-width"
        className={styles.viewFullDetailsButton}
        labelText="View full details"
      />
    </div>
  );
};
